"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var loanCalculation_1 = require("../../../../../../../../helpers/loanCalculation");
var react_redux_1 = require("react-redux");
var currencySlice_1 = require("../../../../../../../../features/currencies/currencySlice");
var currencyConverter_1 = require("../../../../../../../../helpers/currencyConverter");
var numberHelpers_1 = require("../../../../../../../../helpers/numberHelpers");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MonthlyMortgagePerApt = function (_a) {
    var price = _a.price, max_duration = _a.max_duration, min_percent = _a.min_percent, min_prepayment = _a.min_prepayment;
    var t = react_i18next_1.useTranslation('common').t;
    var hasPrice = !!price.length;
    var rate = react_redux_1.useSelector(currencySlice_1.selectExchangeRate);
    var all = react_redux_1.useSelector(currencySlice_1.selectAllExchangeRates);
    var currency = react_redux_1.useSelector(currencySlice_1.selectCurrentCurrency);
    var convertedCurrency = hasPrice && currencyConverter_1.convertToCurrency(price, rate, all, currency, false);
    var monthlyMortgage = react_1.useMemo(function () {
        return (convertedCurrency &&
            loanCalculation_1.handleLoanCalculator(convertedCurrency, min_prepayment, min_percent, max_duration));
    }, [convertedCurrency]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.bl_amenity_list },
        react_1.default.createElement("div", { className: "amenity-item" },
            react_1.default.createElement("div", { className: classnames_1.default('push-left', styles_module_scss_1.default.perAptMortgageText) }, t('POST_PREVIEW.MORTGAGE_SECTION.MONTHLY_MORTGAGE_PER_APT')),
            react_1.default.createElement("div", { className: classnames_1.default('amenity-info', styles_module_scss_1.default.expanded_item) },
                price && (react_1.default.createElement("i", { className: classnames_1.default("icon-ic-" + currency, styles_module_scss_1.default.currencyIcon) })),
                monthlyMortgage &&
                    numberHelpers_1.numberToDecimalString(numberHelpers_1.roundUp(monthlyMortgage, currencyConverter_1.currencyPrecision[currency]))))));
};
exports.default = react_1.memo(MonthlyMortgagePerApt);
